const React = require('react')
const { useState } = require('react')
const { LoadingSpinner, Tabs } = require('@components')
const { AssetMultichain } = require('./multichain.assets')
const { AssetTokens } = require('./tokens.assets')
const { AssetNFTs } = require('./nfts.assets')

require('@styles/pages/address/transactions.address.css')

const AddressAssets = props => {
    const { loading, data } = props

    const [activeTab, setActiveTab] = useState(() => {
        const urlHash = window.location.hash.slice(1)
        return urlHash || 'asset-tokens'
    })

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    <Tabs
                        activeTab={activeTab}
                        items={[
                            { tab: 'asset-multichain', text: 'Multichain Portfolio' },
                            { tab: 'asset-tokens', text: 'Tokens' },
                            { tab: 'asset-nfts', text: 'NFTs' }
                        ]}
                        onTabChange={setActiveTab}
                    />
                    {activeTab === 'asset-multichain' && <AssetMultichain data={data} />}
                    {activeTab === 'asset-tokens' && <AssetTokens data={data} />}
                    {activeTab === 'asset-nfts' && <AssetNFTs data={data} />}
                </>
            )}
        </div>
    )
}

module.exports = { AddressAssets }
